module.exports = __webpack_public_path__ + "static/media/mobile-devices.5b0c1200.svg";